// extracted by mini-css-extract-plugin
module.exports = {"metro":"Metro_metro__kPCHe","metro-link":"Metro_metro-link__EwEck","dots":"Metro_dots__rBoD0","dot":"Metro_dot__JfNeH"};